import React from "react"
import PropTypes from "prop-types"
// Styles
import { Container, Wrapper, GridImage } from "./ImageGrid.styles"

const ImageGrid = ({ pictures }) => {
   return (
      <Container>
         <Wrapper>
            {pictures?.map((item, index) => (
               <GridImage key={index} src={item} />
            ))}
         </Wrapper>
      </Container>
   )
}

ImageGrid.propTypes = {
   pictures: PropTypes.arrayOf(PropTypes.string),
}

export default ImageGrid
